import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <h1 className="font-display text-4xl text-brand-ink">Post not found</h1>
      <Link to="/blog" className="inline-block mt-6 text-brand-red font-semibold">← Back to blog</Link>
    </div>
  );
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24">Loading…</div>;

  return (
    <article data-testid="blog-post-page" className="max-w-3xl mx-auto px-6 md:px-10 py-16">
      <SEO
        title={post.title}
        description={post.excerpt}
        image={post.cover_image}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: post.title,
          description: post.excerpt,
          image: post.cover_image,
          author: { "@type": "Organization", name: post.author || "Cake World USA" },
          datePublished: post.created_at,
        }}
      />
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-brand-stone hover:text-brand-ink mb-8"><ArrowLeft className="w-4 h-4" /> Back to blog</Link>
      <div className="eyebrow">{post.tags?.[0] || "Journal"}</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl text-brand-ink leading-tight">{post.title}</h1>
      <div className="mt-4 text-sm text-brand-stone">{post.author} · {new Date(post.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</div>

      <div className="mt-8 rounded-3xl overflow-hidden border border-brand-line">
        <img src={post.cover_image} alt={post.title} className="w-full h-auto object-cover" />
      </div>

      <div className="mt-10 prose prose-lg max-w-none text-brand-ink whitespace-pre-line leading-relaxed">
        {post.content}
      </div>
    </article>
  );
}
